export const getWord = (word: string, type: number, cssName: any) => {
  if (type === 15) {
    return <img src='https://m.hellobike.com/helloyun3/09475/tkrnw8le_member_card.png' class={cssName}/>;
  }
  return (<span>{word}</span>);
};
